var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M126.8135,133.7109c-0.502,0-91.3291,0-94.0879,0c0-25.0918,0-100.8652,0-128.7202 H108.25v18.8242h18.5635C126.8135,34.605,126.8135,121.6699,126.8135,133.7109z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M140.1191,5.2451c4.0137,0,7.0234,3.2578,7.0234,7.0239 c0,4.0137-3.2646,7.0303-7.0234,7.0303c-4.0205,0-7.0313-3.2642-7.0313-7.0303S136.3525,5.2451,140.1191,5.2451z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M8.3857,105.6074c3.0098,0,5.5186,2.5098,5.5186,5.5195 c0,3.0176-2.5088,5.5254-5.5186,5.5254c-3.0107,0-5.5195-2.5078-5.5195-5.5254C2.8662,108.1172,5.375,105.6074,8.3857,105.6074z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#D8E8F7",
    d: "M108.5039,5.2451c5.7666,5.7729,12.7969,13.0444,18.5635,18.8174h-18.5635V5.2451z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#D8E8F7",
    points: "108.5039,133.7109 108.5039,144.502 21.9316,144.502 21.9316,20.8047  32.7256,20.8047 32.7256,91.5605 32.7256,113.3887 32.7256,133.7109  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7256,
    y: 91.5605,
    fillRule: "evenodd",
    fill: "#D8E8F7",
    width: 77.0293,
    height: 22.082
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M141.8711,24.0625c1.2451,0,2.2617,1.0103,2.2617,2.2612 c0,1.2441-1.0166,2.2544-2.2617,2.2544c-1.2441,0-2.2607-1.0103-2.2607-2.2544 C139.6104,25.0728,140.627,24.0625,141.8711,24.0625z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M135.5967,80.5215c1.251,0,2.2549,1.0098,2.2549,2.2559 c0,1.25-1.0039,2.2598-2.2549,2.2598s-2.2549-1.0098-2.2549-2.2598C133.3418,81.5313,134.3457,80.5215,135.5967,80.5215z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M126.0645,141.7441c1.2441,0,2.2607,1.0098,2.2607,2.2559 c0,1.25-1.0166,2.2598-2.2607,2.2598c-1.2451,0-2.2617-1.0098-2.2617-2.2598 C123.8027,142.7539,124.8193,141.7441,126.0645,141.7441z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    points: "93.6934,105.6074 93.6934,107.8691 85.9199,107.8691 85.9199,97.0781  88.4287,97.0781 88.4287,105.6074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    points: "82.9102,97.0781 82.9102,107.8691 80.3945,107.8691 80.3945,101.3477  77.8857,106.1094 76.6318,106.1094 74.374,101.3477 74.374,107.8691 71.8662,107.8691 71.8662,97.0781 74.374,97.0781  77.3848,102.5977 80.1475,97.0781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    points: "69.3535,97.0781 69.3535,99.0859 66.0957,99.0859 66.0957,107.8691  63.5869,107.8691 63.5869,99.0859 60.3262,99.0859 60.3262,97.0781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    points: "58.0654,97.0781 58.0654,107.8691 55.5566,107.8691 55.5566,103.3535  51.0381,103.3535 51.0381,107.8691 48.5293,107.8691 48.5293,97.0781 51.0381,97.0781 51.0381,101.0918 55.5566,101.0918  55.5566,97.0781  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M22.6875,5.2451c1.2441,0,2.2549,1.0098,2.2549,2.2607 c0,1.2446-1.0107,2.2544-2.2549,2.2544c-1.248,0-2.2578-1.0098-2.2578-2.2544C20.4297,6.2549,21.4395,5.2451,22.6875,5.2451z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M14.6572,90.0547c1.2471,0,2.2607,1.0098,2.2607,2.2539 c0,1.252-1.0137,2.2617-2.2607,2.2617c-1.248,0-2.2578-1.0098-2.2578-2.2617C12.3994,91.0645,13.4092,90.0547,14.6572,90.0547z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M8.3857,42.8804c1.2471,0,2.2578,1.0098,2.2578,2.2607 c0,1.2446-1.0107,2.2549-2.2578,2.2549c-1.248,0-2.2578-1.0103-2.2578-2.2549C6.1279,43.8901,7.1377,42.8804,8.3857,42.8804z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M108.5039,146.0059H21.9316c-0.749,0-1.502-0.75-1.502-1.5039V20.8047 c0-0.7559,0.7529-1.5054,1.502-1.5054h11.041c0.7529,0,1.5088,0.7495,1.5088,1.5054c0,0.7495-0.7559,1.4985-1.5088,1.4985 h-9.5322V142.748h83.5518v-9.0371c0-0.75,0.7559-1.5059,1.5117-1.5059c0.7432,0,1.499,0.7559,1.499,1.5059v10.791 C110.0029,145.2559,109.2471,146.0059,108.5039,146.0059z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M126.8135,25.5679H108.25c-0.7559,0-1.5049-0.7495-1.5049-1.5054V5.2451 c0-0.7495,0.749-1.5054,1.5049-1.5054c0.749,0,1.5049,0.7559,1.5049,1.5054v17.3125h17.0586 c0.7559,0,1.5117,0.7559,1.5117,1.5049C128.3252,24.8184,127.8164,25.5679,126.8135,25.5679z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M126.8135,135.4707H32.7256c-0.7529,0-1.5088-0.7559-1.5088-1.5059v-20.3223 c0-0.7559,0.7559-1.5059,1.5088-1.5059c0.749,0,1.502,0.75,1.502,1.5059v18.8164h91.0869V24.5645 c-2.7627-2.7627-5.7725-6.021-8.7832-9.0313c-3.0098-3.0103-6.0273-6.2744-8.7832-9.0308H34.4814v84.5562 c0,0.748-0.7559,1.5039-1.5088,1.5039c-0.752,0-1.502-0.7559-1.502-1.5039V5.2451c0-0.7495,0.75-1.5054,1.502-1.5054h75.5313 c0.4951,0,0.7432,0.2539,0.9971,0.502c3.0166,3.0103,6.0273,6.2744,9.2852,9.5322c3.0098,3.2646,6.2676,6.5293,9.2852,9.2852 c0.2539,0.2544,0.501,0.7559,0.501,1.0034v109.9023C128.5723,134.7148,127.8164,135.4707,126.8135,135.4707z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M8.3857,118.1582c-4.0176,0-7.0273-3.2656-7.0273-7.0313 c0-4.0137,3.2637-7.0234,7.0273-7.0234c4.0137,0,7.0234,3.2637,7.0234,7.0234C15.4092,114.8926,12.3994,118.1582,8.3857,118.1582 L8.3857,118.1582z M8.3857,107.1133L8.3857,107.1133c-2.2578,0-4.0176,1.7598-4.0176,4.0137 c0,2.2617,1.7598,4.0195,4.0176,4.0195s4.0137-1.7578,4.0137-4.0195C12.3994,108.873,10.6436,107.1133,8.3857,107.1133z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M140.1191,20.8047c-4.7705,0-8.5361-3.7661-8.5361-8.5356 c0-4.7632,3.7656-8.5293,8.5361-8.5293c4.7627,0,8.5225,3.7661,8.5225,8.5293 C148.6416,17.0386,144.8818,20.8047,140.1191,20.8047L140.1191,20.8047z M140.1191,6.75L140.1191,6.75 c-3.0107,0-5.5254,2.5088-5.5254,5.519c0,3.0166,2.5146,5.519,5.5254,5.519c3.0098,0,5.5117-2.5024,5.5117-5.519 C145.6309,9.2588,143.1289,6.75,140.1191,6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M109.7549,114.8926H32.7256c-0.7529,0-1.5088-0.748-1.5088-1.5039v-22.082 c0-0.75,0.7559-1.5059,1.5088-1.5059h76.7754c0.7559,0,1.5049,0.7559,1.5049,1.5059v22.082 C111.2539,114.3906,110.5039,114.8926,109.7549,114.8926L109.7549,114.8926z M34.4814,111.8828L34.4814,111.8828H108.25V93.0645 H34.4814V111.8828z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M51.543,41.375h-4.7695c-0.7529,0-1.5049-0.749-1.5049-1.5049 c0-0.7495,0.752-1.5054,1.5049-1.5054h4.7695c0.7529,0,1.5049,0.7559,1.5049,1.5054C53.2988,40.626,52.5459,41.375,51.543,41.375 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M51.543,49.1548h-4.7695c-0.7529,0-1.5049-0.7559-1.5049-1.5049 c0-0.7559,0.752-1.5054,1.5049-1.5054h4.7695c0.7529,0,1.5049,0.7495,1.5049,1.5054 C53.2988,48.3989,52.5459,49.1548,51.543,49.1548z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M51.543,56.9351h-4.7695c-0.7529,0-1.5049-0.7559-1.5049-1.5054 c0-0.7559,0.752-1.5117,1.5049-1.5117h4.7695c0.7529,0,1.5049,0.7559,1.5049,1.5117 C53.2988,56.1792,52.5459,56.9351,51.543,56.9351z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M51.543,64.7148h-4.7695c-0.7529,0-1.5049-0.7559-1.5049-1.5117 c0-0.7495,0.752-1.4985,1.5049-1.4985h4.7695c0.7529,0,1.5049,0.749,1.5049,1.4985 C53.2988,64.2065,52.5459,64.7148,51.543,64.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M51.543,72.7422h-4.7695c-0.7529,0-1.5049-0.7559-1.5049-1.5049 c0-0.7559,0.752-1.5054,1.5049-1.5054h4.7695c0.7529,0,1.5049,0.7495,1.5049,1.5054 C53.2988,71.9863,52.5459,72.7422,51.543,72.7422z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M51.543,80.5215h-4.7695c-0.7529,0-1.5049-0.7559-1.5049-1.5117 c0-0.748,0.752-1.5039,1.5049-1.5039h4.7695c0.7529,0,1.5049,0.7559,1.5049,1.5039 C53.0479,79.7656,52.5459,80.5215,51.543,80.5215z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M62.5811,41.375h-4.7666c-0.7559,0-1.5049-0.749-1.5049-1.5049 c0-0.7495,0.749-1.5054,1.5049-1.5054h4.7666c0.752,0,1.5078,0.7559,1.5078,1.5054C64.0889,40.626,63.333,41.375,62.5811,41.375z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M79.8994,41.375H68.8555c-0.7529,0-1.5088-0.749-1.5088-1.5049 c0-0.7495,0.7559-1.5054,1.5088-1.5054h11.0439c0.749,0,1.499,0.7559,1.499,1.5054C81.3984,40.626,80.6484,41.375,79.8994,41.375 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M64.0889,49.1548h-6.2744c-0.7559,0-1.5049-0.7559-1.5049-1.5049 c0-0.7559,0.749-1.5054,1.5049-1.5054h6.2744c0.7529,0,1.502,0.7495,1.502,1.5054 C65.8418,48.3989,65.0889,49.1548,64.0889,49.1548z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M84.6621,49.1548H70.6113c-0.7559,0-1.5049-0.7559-1.5049-1.5049 c0-0.7559,0.749-1.5054,1.5049-1.5054h14.0508c0.75,0,1.5059,0.7495,1.5059,1.5054 C86.168,48.3989,85.4121,49.1548,84.6621,49.1548z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M65.8418,56.9351h-7.7764c-0.7529,0-1.5049-0.7559-1.5049-1.5054 c0-0.7559,0.752-1.5117,1.5049-1.5117h7.7764c0.7559,0,1.5049,0.7559,1.5049,1.5117 C67.3467,56.1792,66.5977,56.9351,65.8418,56.9351z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M93.9473,56.9351H71.8662c-0.7529,0-1.5059-0.7559-1.5059-1.5054 c0-0.7559,0.7529-1.5117,1.5059-1.5117h22.0811c0.75,0,1.499,0.7559,1.499,1.5117 C95.4463,56.1792,94.6973,56.9351,93.9473,56.9351z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M72.1162,64.7148H58.0654c-0.7529,0-1.5049-0.7559-1.5049-1.5117 c0-0.7495,0.752-1.4985,1.5049-1.4985h14.0508c0.7529,0,1.5059,0.749,1.5059,1.4985 C73.6221,64.2065,72.8691,64.7148,72.1162,64.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M81.3984,64.7148h-3.2617c-0.752,0-1.5049-0.7559-1.5049-1.5117 c0-0.7495,0.7529-1.4985,1.5049-1.4985h3.2617c0.7559,0,1.5117,0.749,1.5117,1.4985 C82.9102,64.2065,82.1543,64.7148,81.3984,64.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M92.4355,64.7148h-4.7627c-0.749,0-1.5049-0.7559-1.5049-1.5117 c0-0.7495,0.7559-1.4985,1.5049-1.4985h4.7627c0.7559,0,1.5117,0.749,1.5117,1.4985 C93.9473,64.2065,93.1914,64.7148,92.4355,64.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M62.5811,72.7422h-4.7666c-0.7559,0-1.5049-0.7559-1.5049-1.5049 c0-0.7559,0.749-1.5054,1.5049-1.5054h4.7666c0.752,0,1.5078,0.7495,1.5078,1.5054 C64.0889,71.9863,63.333,72.7422,62.5811,72.7422z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M79.8994,72.7422H68.8555c-0.7529,0-1.5088-0.7559-1.5088-1.5049 c0-0.7559,0.7559-1.5054,1.5088-1.5054h11.0439c0.749,0,1.499,0.7495,1.499,1.5054 C81.3984,71.9863,80.6484,72.7422,79.8994,72.7422z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M92.4355,72.7422H86.168c-0.7559,0-1.5059-0.7559-1.5059-1.5049 c0-0.7559,0.75-1.5054,1.5059-1.5054h6.2676c0.7559,0,1.5117,0.7495,1.5117,1.5054 C93.9473,71.9863,93.1914,72.7422,92.4355,72.7422z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M64.0889,80.5215h-6.2744c-0.7559,0-1.5049-0.7559-1.5049-1.5117 c0-0.748,0.749-1.5039,1.5049-1.5039h6.2744c0.7529,0,1.502,0.7559,1.502,1.5039 C65.5908,79.7656,65.0889,80.5215,64.0889,80.5215z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M84.6621,80.5215H70.6113c-0.7559,0-1.5049-0.7559-1.5049-1.5117 c0-0.748,0.749-1.5039,1.5049-1.5039h14.0508c0.75,0,1.5059,0.7559,1.5059,1.5039 C86.168,79.7656,85.4121,80.5215,84.6621,80.5215z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M56.3096,31.8423c-0.251,0-0.7529,0-1.0039-0.2539l-7.7793-6.2681 c-0.251-0.2544-0.502-0.7559-0.502-1.2578c0-0.5015,0.251-1.0034,0.502-1.251l7.7793-6.2749 c0.7529-0.5015,1.7529-0.5015,2.2578,0.2544c0.502,0.749,0.502,1.7524-0.251,2.2544l-6.2744,5.0171l6.2744,5.0171 c0.7529,0.502,0.7529,1.5054,0.251,2.2612C57.3125,31.5884,56.8105,31.8423,56.3096,31.8423z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M75.127,31.8423c-0.502,0-1.0039-0.2539-1.2539-0.5015 c-0.499-0.7559-0.499-1.7593,0.25-2.2612l6.2715-5.0171l-6.2715-5.0171c-0.749-0.502-0.749-1.5054-0.25-2.2607 c0.501-0.7495,1.5049-0.7495,2.2568-0.248l7.7832,6.2749c0.248,0.2476,0.4951,0.7495,0.4951,1.251 c0,0.502-0.2471,1.0034-0.4951,1.2578l-7.7832,6.2681C75.8789,31.8423,75.3779,31.8423,75.127,31.8423z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#A8CDEB",
    d: "M62.5811,30.3374c-0.251,0-0.502,0-0.75-0.2476 c-0.752-0.5083-1.0068-1.5117-0.5049-2.2612l6.2754-11.0376c0.501-0.7559,1.5049-1.0103,2.2539-0.5083 c0.7559,0.5083,1.0068,1.5054,0.5049,2.2607l-6.5225,11.0381C63.5869,30.0898,63.082,30.3374,62.5811,30.3374z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoIcon2);
export default __webpack_public_path__ + "static/media/who-icon-2.9e62bfd45a97dc9ab67296c423e92233.svg";
export { ForwardRef as ReactComponent };